module.exports = {"name":"cardbackCTA","meta":{"description":"Add Signup and Watch CTAs to public board cardbacks","link":"https://trello.com/c/TT8okxLq"},"audiences":["allMembers"],"experimentAllocation":{"allMembers":1},"defaultWeight":1,"experimentVersion":"v1","defaults":{"watch":false,"signup":false},"variations":[{"name":"watch","weight":1,"values":{"watch":true,"signup":false}},{"name":"signup","weight":1,"values":{"watch":false,"signup":true}},{"name":"watchAndSignup","weight":1,"values":{"watch":true,"signup":true}}],"autoTrack":true}


//////////////////
// WEBPACK FOOTER
// ./app/common/lib/experiments/config/cardbackCTA.json
// module id = 1RbY
// module chunks = 12